<header>
    <div class="fullwidth-cnt visual-background"
         ref="headerVisual"
         :class="pathImageBck !== '' ? 'visual-background--' + pathImageBck : 'null'">
        <div class="text-center">
            <h1>{{ t('header.title') }}</h1>
            <template v-if="pathImageBck === '2023' || pathImageBck === '2022' || pathImageBck === '2021'">
                <span class="subtitle" v-html="t('header.subtitle.other')"></span>
            </template>
            <template v-else>
                <span class="subtitle" v-html="t('header.subtitle')"></span>
            </template>

        </div>
        <!--        <div class="visual-body" v-if="visual"></div>-->
    </div>
</header>